import React from 'react';

import { ToastProvider } from 'Context/ToastContext';

const App = ({ children }) => {
    return <ToastProvider>{children}</ToastProvider>;
};

export default App;
